import React from 'react';

export function PageLoader({ label = 'Yükleniyor…' }) {
  return (
    <div className="page-loader" role="status" aria-live="polite">
      <div className="spinner" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}
